import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-service_close",
  "use": "icon-service_close-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-service_close\"><g fill=\"none\" fill-rule=\"evenodd\" opacity=\".6\"><circle fill=\"#FFF\" fill-rule=\"nonzero\" cx=\"22\" cy=\"22\" r=\"22\" /><path d=\"m11.733 11.733 20.17 20.17m-20.17 0 20.17-20.17\" stroke=\"#CCC\" stroke-width=\"4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol